var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.123,
    height: 38.916,
    viewBox: "0 0 33.123 38.916",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18079.857 19811.113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.149,59.2l-3.212-1.284c-.286-.071-.357-.356-.286-.642s.357-.356.642-.285l3.212,1.284c.286.071.357.356.286.642S60.434,59.274,60.149,59.2Z",
    transform: "translate(-18124.213 -19849.994)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.838,55.746l-11.85-4.635c-.286-.071-.357-.356-.286-.642s.357-.356.642-.285l11.85,4.635c.286.071.357.357.286.642S72.124,55.817,71.838,55.746Z",
    transform: "translate(-18125.123 -19847.963)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.569,70.946,66.5,70.519c-.286-.071-.357-.356-.286-.642s.357-.357.642-.285l1.071.428c.286.071.357.356.286.642A.528.528,0,0,1,67.569,70.946Z",
    transform: "translate(-18127.064 -19853.752)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.919,68.31l-6.425-2.567c-.286-.071-.357-.356-.286-.642s.357-.356.642-.285l6.425,2.567c.286.071.357.357.286.642A.5.5,0,0,1,60.919,68.31Z",
    transform: "translate(-18123.484 -19852.326)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.525,40.613l-8.638-3.423c-.286-.071-.357-.357-.286-.642s.357-.357.642-.285l8.638,3.494c.286.071.357.357.286.642S74.811,40.756,74.525,40.613Z",
    transform: "translate(-18126.883 -19843.811)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.511,50.823l-8,3.494a.478.478,0,1,1-.428-.856l8-3.494a.49.49,0,0,1,.642.214A.435.435,0,0,1,61.511,50.823Z",
    transform: "translate(-18123.078 -19847.889)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.857,43.812l-3.07,1.355a.478.478,0,1,1-.428-.856l3.07-1.355a.49.49,0,0,1,.642.214A.449.449,0,0,1,60.857,43.812Z",
    transform: "translate(-18124.352 -19845.799)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.637,73.685l-1.071.5a.478.478,0,1,1-.428-.856l1.071-.5a.478.478,0,1,1,.428.856Z",
    transform: "translate(-18122.197 -19854.707)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.642,36.9,43.649,41.751a.478.478,0,1,1-.428-.856l10.993-4.849a.478.478,0,1,1,.428.856Z",
    transform: "translate(-18120.135 -19843.738)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.446,80.031h-1.5a.642.642,0,1,1,0-1.284h1.5a.642.642,0,1,1,0,1.284Z",
    transform: "translate(-18123.223 -19856.49)",
    fill: "#e2ebff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18077.643 -19807.689)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.437,42.275a13.274,13.274,0,0,1-3-.856c-3-1.355-7.924-5.348-10.636-5.348s-7.638,3.993-10.636,5.348a12.287,12.287,0,0,1-3,.856,1.95,1.95,0,0,0-1.856,2.139A73.181,73.181,0,0,0,45.167,57.82C47.523,65.307,54.162,69.8,56.732,71.3a2,2,0,0,0,2,0c2.57-1.5,9.28-5.99,11.564-13.477A73.181,73.181,0,0,0,73.15,44.414,1.738,1.738,0,0,0,71.437,42.275Z",
    transform: "translate(-42.296 -36.071)",
    fill: "#84a2ff",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.894,38.109a13.275,13.275,0,0,1-3-.856c-3-1.355-7.924-5.348-10.636-5.348s-7.638,3.922-10.636,5.348a12.288,12.288,0,0,1-3,.856,1.95,1.95,0,0,0-1.856,2.139,73.18,73.18,0,0,0,2.855,13.405c2.427,7.487,9.137,11.979,11.707,13.477a2,2,0,0,0,2,0c2.57-1.5,9.28-5.99,11.564-13.477A73.18,73.18,0,0,0,70.75,40.248,1.878,1.878,0,0,0,68.894,38.109Z",
    transform: "translate(-18119.182 -19842.52)",
    fill: "#cfae26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.727,38.109a1.95,1.95,0,0,0-1.856,2.139,73.181,73.181,0,0,0,2.855,13.405c2.356,7.487,9.066,11.979,11.636,13.477a2,2,0,0,0,2,0c2.57-1.5,9.28-5.99,11.564-13.477A73.181,73.181,0,0,0,70.78,40.248a1.878,1.878,0,0,0-1.856-2.139,13.274,13.274,0,0,1-3-.856c-3-1.355-7.924-5.348-10.636-5.348a9.675,9.675,0,0,0-4.426,1.711",
    transform: "translate(-18119.211 -19842.52)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.263,37.494a24.4,24.4,0,0,1-2.57,1.426",
    transform: "translate(-18121.252 -19844.186)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.54,43.157a59.931,59.931,0,0,1-1.5,7.63,16.638,16.638,0,0,1-.5,1.783,14.364,14.364,0,0,1-.5,1.64c-1.785,5.7-6.71,9.27-9.137,10.7h-.143a6.269,6.269,0,0,0-.714-.428c-2.57-1.711-6.71-5.063-8.281-10.2-.357-1.212-.714-2.353-1-3.494a59.929,59.929,0,0,1-1.5-7.63,13.08,13.08,0,0,0,2.855-.927,40.976,40.976,0,0,0,3.641-2.068c1.428-.856,3.926-2.424,4.926-2.567h.143c.928,0,3.569,1.64,5.068,2.567a40.978,40.978,0,0,0,3.641,2.068A19.392,19.392,0,0,0,68.54,43.157Z",
    transform: "translate(-18120.826 -19844.217)",
    fill: "#ba9c21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.864,37.6v13.12H46.87a59.932,59.932,0,0,1-1.5-7.63,13.078,13.078,0,0,0,2.855-.927,40.968,40.968,0,0,0,3.641-2.068C53.366,39.307,55.864,37.738,56.864,37.6Z",
    transform: "translate(-18120.857 -19844.217)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.956,56.393a16.62,16.62,0,0,1-.5,1.783,14.358,14.358,0,0,1-.5,1.64c-1.785,5.7-6.71,9.27-9.137,10.7h-.071V56.393Z",
    transform: "translate(-18125.74 -19849.822)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.783,62.185c-1.927,5.348-6.639,8.7-8.923,10.125h-.143A6.275,6.275,0,0,0,60,71.883,21.361,21.361,0,0,1,58.29,70.6",
    transform: "translate(-18124.709 -19851.551)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,38.815c1,.57,2.142,1.212,2.927,1.711a40.959,40.959,0,0,0,3.641,2.068,14.647,14.647,0,0,0,2.855.927,55.378,55.378,0,0,1-1.071,6.061",
    transform: "translate(-18126.711 -19844.58)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.115,48.525a30.6,30.6,0,0,1-.642-4.064,13.078,13.078,0,0,0,2.855-.927c.857-.428,1.856-1,2.855-1.569",
    transform: "translate(-18120.887 -19845.52)",
    fill: "none",
    stroke: "#182052",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.705908690f53473de3a82f65bf58deb8.svg";
export { ForwardRef as ReactComponent };